import React, { Fragment } from 'react';
import { withApollo } from 'react-apollo';

import { DetachFlight } from '../../../../mutations/DetachFlight';
import { ClaimFlightView as FlightView } from '../../../FlightView';
import AddFlight from '../../../AddFlight';

const Flights = ({
  flight,
  flights,
  passengerTicketId,
  onClaimUpdated,
  hideLoading,
  showLoading,
  client,
  previewOnly
}) => {
  const handleRemoveFlight = flightId => {
    showLoading();
    client
      .mutate({
        mutation: DetachFlight,
        variables: {
          input: {
            flightId,
            passengerTicketId
          }
        }
      })
      .then(() => {
        hideLoading();
        onClaimUpdated();
      })
      .catch(() => hideLoading());
  };
  const flightWithoutAirline = flights.find(({ flight }) => !flight.airline);
  return (
    <Fragment>
      <FlightView
        claimFlightId={flight.id}
        flights={flights}
        handleRemoveFlight={!flightWithoutAirline ? handleRemoveFlight : null}
      />
      {!previewOnly && !flightWithoutAirline && (
        <AddFlight
          onFlightCreated={onClaimUpdated}
          passengerTicketId={passengerTicketId}
        />
      )}
    </Fragment>
  );
};

export default withApollo(Flights);



// WEBPACK FOOTER //
// ./src/component/ClaimPage/ClaimDetails/Flights/index.js